import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  ref: "aboutSection",
  id: "about-section",
  class: "about-section wrapper main-section"
}
const _hoisted_2 = {
  ref: "devTilesSection",
  id: "dev-projects",
  class: "tile-section wrapper main-section"
}
const _hoisted_3 = {
  ref: "designTilesSection",
  id: "design-projects",
  class: "tile-section wrapper main-section"
}
const _hoisted_4 = {
  id: "contact-form",
  class: "contact-section wrapper main-section"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AboutSection = _resolveComponent("AboutSection")!
  const _component_TilesSection = _resolveComponent("TilesSection")!
  const _component_MailForm = _resolveComponent("MailForm")!

  return (_openBlock(), _createElementBlock("main", null, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.wasSectionLoaded['about-section'])
        ? (_openBlock(), _createBlock(_component_AboutSection, { key: 0 }))
        : _createCommentVNode("", true)
    ], 512),
    _createElementVNode("div", _hoisted_2, [
      (_ctx.wasSectionLoaded['dev-projects'])
        ? (_openBlock(), _createBlock(_component_TilesSection, {
            key: 0,
            sectionTitle: "Web-Dev Projects",
            modalComp: _ctx.ProjectModal,
            contents: _ctx.devProjects
          }, null, 8, ["modalComp", "contents"]))
        : _createCommentVNode("", true)
    ], 512),
    _createElementVNode("div", _hoisted_3, [
      (_ctx.wasSectionLoaded['design-projects'])
        ? (_openBlock(), _createBlock(_component_TilesSection, {
            key: 0,
            sectionTitle: "Graphic Design",
            modalComp: _ctx.DesignModal,
            contents: _ctx.graphicDesign
          }, null, 8, ["modalComp", "contents"]))
        : _createCommentVNode("", true)
    ], 512),
    _createElementVNode("div", _hoisted_4, [
      (_ctx.wasSectionLoaded['contact-form'])
        ? (_openBlock(), _createBlock(_component_MailForm, { key: 0 }))
        : _createCommentVNode("", true)
    ])
  ]))
}